var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "w-100 h-100 d-flex flex-column align-items-start justify-content-between pb-4",
    },
    [
      _c("TextArea", {
        staticClass: "mb-2 w-100 styled-text-area",
        attrs: {
          id: "inputPrompt",
          name: "prompt",
          "border-class": "br-4",
          aiCustom: true,
          skipFocus: true,
          rows: "4",
          "max-characters": 4000,
          label: _vm.getTextAreaPlaceholder,
          type: "text",
        },
        model: {
          value: _vm.prompt,
          callback: function ($$v) {
            _vm.prompt = $$v
          },
          expression: "prompt",
        },
      }),
      _vm._v(" "),
      _c("TextInput", {
        staticClass: "w-100 styled-text-input",
        attrs: {
          id: "inputNegativePrompt",
          "border-class": "br-4",
          aiCustom: true,
          type: "text",
          name: "negative_prompt",
          label: _vm.getTextInputPlaceholder,
        },
        model: {
          value: _vm.negative_prompt,
          callback: function ($$v) {
            _vm.negative_prompt = $$v
          },
          expression: "negative_prompt",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }